export const FETCH_PREFECTURES_REQUEST = 'FETCH_PREFECTURES_REQUEST'
export const SET_PREFECTURES_DATA = 'SET_PREFECTURES_DATA'
export const FETCH_STATIONS_REQUEST = 'FETCH_STATIONS_REQUEST'
export const SET_STATIONS_DATA = 'SET_STATIONS_DATA'
export const FETCH_FACILITIES_REQUEST = 'FETCH_FACILITIES_REQUEST'
export const SET_FACILITIES_DATA = 'SET_FACILITIES_DATA'
export const FETCH_LOCATION_DETAIL_REQUEST = 'FETCH_LOCATION_DETAIL_REQUEST'
export const SET_LOCATION_DETAIL_DATA = 'SET_LOCATION_DETAIL_DATA'
